var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"headline text-center",attrs:{"text":"","prominent":"","color":"primary","border":"right"}},[_c('div',{staticClass:"mx-5 pre-formatted text-justify-last-center",domProps:{"textContent":_vm._s(_vm.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }